import { css } from 'lit';

export const styles = css`
  :host {
    --column-gap: calc(15rem / var(--default-rem-px-count));
    --selected-variant-padding-width: 2px;
    --selected-variant-border-width: 1px;
  }

  :host(:not(:last-child)) > .expanded {
    padding-bottom: calc(40em / var(--default-rem-px-count));
  }

  .barrel-wrapper {
    height: calc(60em / var(--default-rem-px-count));
    overflow: hidden;
  }

  .expanded {
    height: unset;
  }

  .hide {
    display: hidden;
  }

  .barrel-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: calc(60em / var(--default-rem-px-count));
    border-top: 2px solid #222222;
  }

  .barrel-header span {
    display: flex;
    align-items: center;
  }

  .barrel-heavy-text {
    font-weight: 500;
  }

  .barrel-header-icon {
    display: flex;
    justify-content: right;
    min-height: 2em;
    min-width: 2em;
  }

  .barrel-text {
    padding-bottom: calc(20em / var(--default-rem-px-count));
    line-height: 1.45em;
  }

  .pattern-options-wrapper {
    width: 100%;
    padding-top: calc(6em / var(--default-rem-px-count));
    padding-bottom: calc(20em / var(--default-rem-px-count));
    margin-bottom: calc(20em / var(--default-rem-px-count));
    border-bottom: 1px solid #c0c0c0;
  }

  .hardware-options-wrapper {
    width: 100%;
  }

  .hardware-options-header {
    padding-bottom: calc(16em / var(--default-rem-px-count));
  }

  .pattern-options-wrapper:last-child {
    border-bottom: none;
  }

  .swatches {
    width: 100%;
    display: inline-grid;
    gap: calc(15em / var(--default-rem-px-count));
    grid-template-columns: repeat(
      4,
      minmax(0, calc(100em / var(--default-rem-px-count)))
    );
  }

  .swatch-wrapper {
    display: flex;
    flex-direction: column;
    padding-bottom: calc(20em / var(--default-rem-px-count));
  }

  .needs-border {
    border: 0.5px solid #c0c0c0;
  }

  .swatch-group {
    padding-bottom: calc(14em / var(--default-rem-px-count));
  }

  p.swatch-group-header {
    font-size: calc(14em / var(--default-rem-px-count));
    font-style: normal;
    font-weight: 500;
    line-height: calc(14em / var(--default-rem-px-count));
    letter-spacing: -0.18px;
    padding: calc(8em / var(--default-rem-px-count)) 0;
  }

  .color-swatch span {
    width: 100%;
    display: block;
    aspect-ratio: 761 / 1000;
  }

  .image-swatch img {
    width: 100%;
    height: 100%;
  }

  .swatches {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .swatch-name {
    font-size: calc(10em / var(--default-rem-px-count));
    letter-spacing: -0.15px;
    padding-top: 2px;
    padding-left: calc(
      var(--selected-variant-padding-width) +
        var(--selected-variant-border-width)
    );
    line-height: 1.3em;
    text-wrap: balance;
  }

  .selected-swatch {
    padding: var(--selected-variant-padding-width);
    border: var(--selected-variant-border-width) solid #222222;
  }

  .not-selected-swatch {
    padding: calc(
      var(--selected-variant-padding-width) +
        var(--selected-variant-border-width)
    );
  }

  .swatch-controls {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: calc(20em / var(--default-rem-px-count));
  }

  .swatch-page-controls {
    display: flex;
  }

  .swatch-page-controls span {
    cursor: pointer;
    width: calc(40em / var(--default-rem-px-count));
    height: calc(40em / var(--default-rem-px-count));
    display: flex;
    align-items: center;
  }

  .swatch-page-controls span {
    justify-content: center;
    margin: calc(5em / var(--default-rem-px-count));
  }

  .swatch-page-controls:hover span {
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.4);
  }

  .swatch-page-controls span img {
    width: 45%;
    height: 45%;
  }

  .no-results {
    height: calc(100em / var(--default-rem-px-count));
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .left-arrow {
    transform: rotate(180deg);
  }

  cta-button {
    margin-top: calc(30em / var(--default-rem-px-count));
    display: block;
    width: calc(50% - var(--column-gap));
  }

  .pattern-filters {
    display: flex;
    flex-direction: column;
    column-gap: var(--column-gap);
  }

  .input-wrapper {
    flex-grow: 1;
    position: relative;
    display: flex;
  }

  .input-wrapper.search {
    border: 1px solid #222222;
  }

  .search input {
    width: 100%;
  }

  /* Override browser defaults */
  input {
    -webkit-appearance: none;
    outline: none;
    box-shadow: none;
    border: none;
    padding: 0;
    background: none;
  }

  input {
    height: calc(42rem / var(--default-rem-px-count));
    width: 100%;
    padding-top: calc(4rem / var(--default-rem-px-count));
    padding-left: calc(16rem / var(--default-rem-px-count));
    display: block;
  }

  .search-icon {
    padding-top: calc(4rem / var(--default-rem-px-count));
    padding-right: calc(16rem / var(--default-rem-px-count));
    height: calc(16rem / var(--default-rem-px-count));
    margin: auto;
  }

  @media print {
    .barrel-header {
      border-top: 1px solid #222222;
    }

    .barrel-heavy-text {
      font-size: 10px;
      letter-spacing: -0.05px;
      line-height: 18px;
    }
  }
`;
